module.exports = __webpack_public_path__ + "img/HQ-ENC-C-V1-T.1e3b6783.jpg";